// extracted by mini-css-extract-plugin
export default {"button":"Button_button__5w0VW","humed":"Button_humed__tffQY","arrowIcon":"Button_arrowIcon__1oSvT"};